/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useCallback, useEffect } from 'react';
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { createUrl } from '../../../redux/helper/CreateQuery';
import { distributorService } from '../../../service/distributor.service';

function CustomerWiseFilterModal({
    filterModal, setFilterModal, handleClear, customerWiseOutstandingList, setCustomerWiseOutstandingtList, Filter, setFilter, handleFilter, SetSuccessMessage,
}) {
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [selectedType, setselectedType] = useState('customer_code');
    const [searchValue, serSearchValue] = useState('');
    const [distributorSearchResult, setdistributorSearchResult] = useState([]);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const onChangeSearch = (value) => {
        serSearchValue(value);
        distributorService.DistributorList(1, value, '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    };

    useEffect(() => {
        distributorService.DistributorList(1, '', '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'customer_code':
                if (Filter[key].length > 0) {
                    final += `&customer_code=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };
    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('customer_code')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block ${selectedType === 'customer_code' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-type"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pilltype"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Customer Code
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className="tab-pane fade show active px-3" id="pills-type" role="tabpanel" aria-labelledby="pillcategorie">
                                    <div className="dropdown relative">
                                        <input
                                            type="text"
                                            id="distributors"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            autoComplete="off"
                                            value={searchValue}
                                            placeholder="Search Customer Code"
                                            className="dropdown-to h-[30px] w-[238px] outline-0 border rounded-t-[4px] border-[#D8D8D8] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                            onClick={() => setSearchDropdown(!searchDropdown)}
                                            onChange={(e) => {
                                                { onChangeSearch((e.target.value).trim()); }
                                            }}
                                        />
                                        {distributorSearchResult && searchDropdown
                                        && (
                                            <ul className="dropdown-menu  absolute h-[145px] w-[245px] overflow-y-auto overflow-x-hidden bg-[#FFFFFF]  shadow-s2 z-[9999] right-[11px]" aria-labelledby="HIP14">
                                                {distributorSearchResult.length > 0 && distributorSearchResult.map((ele, disIdx) => (
                                                    <li className="py-[8px] pl-[5px]">
                                                        <div className="flex items-center" key={disIdx}>
                                                            <Checkbox
                                                                icon={
                                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.customer_code?.includes(ele.ACCOUNT_NUMBER) ? '#555259' : ''}` }} />
                                                                }
                                                                name="my-input"
                                                                className="cursor-pointer"
                                                                checked={Filter.customer_code?.includes(ele.ACCOUNT_NUMBER)}
                                                                onChange={() => HandleFilter('customer_code', ele.ACCOUNT_NUMBER)}
                                                                borderColor={`${Filter.customer_code?.includes(ele.ACCOUNT_NUMBER) ? '#B8C5DC' : '#555259'}`}
                                                                style={{ cursor: 'pointer' }}
                                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                            />
                                                            <label htmlFor="mn50" className="consumbales pl-3 text-sm46 font-normal text-[#090406] text-left cursor-pointer">{ele.ACCOUNT_NUMBER}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-5">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}

                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CustomerWiseFilterModal;
